import { safeDefineElement } from '@/scripts/core/global'
import { ProductForm } from '@/scripts/product/product-form'
import { ProductModal } from '@/scripts/product/product-modal'
import { ProductGallery } from '@/scripts/product/product-gallery'
import { ProductTabs } from '@/scripts/product/product-tabs'
import { ProductRecommendations } from '@/scripts/theme/product-recommendations'
import { ProductDetail } from '@/scripts/product/product-detail'
import { ProductRitual } from '@/scripts/product/product-ritual'
import { StickyAddToBag } from '@/scripts/product/sticky-add-to-bag'
import { initRebuyBundleI18n } from '@/scripts/optional/rebuy-bundle-i18n'
import { initRebuyBundleSlider } from '@/scripts/optional/rebuy-bundle-slider'

safeDefineElement(ProductForm)
safeDefineElement(ProductModal)
safeDefineElement(ProductGallery)
safeDefineElement(ProductTabs)
safeDefineElement(ProductDetail)
safeDefineElement(ProductRecommendations)
safeDefineElement(ProductRitual)
safeDefineElement(StickyAddToBag)

initRebuyBundleI18n()
initRebuyBundleSlider()

//safeDefineElement(VariantSelects)
//safeDefineElement(VariantRadios)
